import TestimonialCard from "../../../Components/CustomTestimonialCard/TestimonialCard";
import Marquee from "react-fast-marquee";
import { Box, Typography } from "@mui/material";
import {
  customersTestemonials,
  customersTestemonials2,
} from "../../../assets/customer/customer";

const Testimonial = () => {
  
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        paddingBottom: "100px",
      }}
    >
      <Box className="section-header-dark align-text-center">
        <Typography variant="h2" className="sec-tittle-color">
          Testimonials
        </Typography>
        <p>Words of praise from others about our presence.</p>
      </Box>

      <Marquee
        speed={80}
        gradient={true}
        gradientColor="rgba(248, 251, 253, 1), rgba(248, 251, 253, 0)"
        gradientWidth={"20%"}
      >
        {customersTestemonials.map((testimonial, index) => (
          <TestimonialCard
            key={index}
            text={testimonial.text}
            author={testimonial.author}
            image={
              testimonial?.image ??
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQABqQIdskCD9BK0I81EbVfV9tTz320XvJ35A&s"
            }
          />
        ))}
      </Marquee>

      <Marquee
        speed={80}
        direction="right"
        gradient={true}
        gradientColor="rgba(248, 251, 253, 1), rgba(248, 251, 253, 0)"
        gradientWidth={"20%"}
      >
        {customersTestemonials2.map((testimonial, index) => (
          <TestimonialCard
            key={index}
            text={testimonial.text}
            author={testimonial.author}
            image={
              testimonial.image ??
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQABqQIdskCD9BK0I81EbVfV9tTz320XvJ35A&s"
            }
          />
        ))}
      </Marquee>
    </Box>
  );
};

export default Testimonial;
